import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from "@material-ui/core/TextField";
import useAxiosInstance from "../../api/axiosApi";

export default function ActivateLicenseDialog (props) {

    const [code, setCode] = useState("");
    const [errors, setErrors] = useState({});

    const axiosInstance = useAxiosInstance(props);

    useEffect( () => {

    }, []);

    const activate = () => {
        axiosInstance.post('/api/license/_activate/'+code).then(response => {
            props.onClose(true);
        }).catch(err => {
            setErrors({"code": "This license code is not valid."})
        });
    };

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={() => props.onClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Activate a license</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please enter here below a license code provided by your organization/school.
                    </DialogContentText>
                    <Grid container justify="space-between" style={{marginTop: 2 + "em"}}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                label="Code"
                                value={code}
                                fullWidth
                                autoComplete="on"
                                onChange={event => setCode(event.target.value)}
                                error={ errors.code || errors.code ? true : false}
                                helperText={errors.code || errors.code}
                            />

                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={activate} color="primary">
                        Activate
                    </Button>
                    <Button onClick={() => props.onClose(false)} color="secondary" autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}